import { ColumnSetting } from '../../../_foundation/models/grid.models';

export const columns: ColumnSetting[] = [
  {
    field: 'changeType',
    title: 'Type of change',
    filter: 'text',
    filterable: false,
    width: 80
  },
  {
    field: 'changeDescription',
    title: 'Description',
    filter: 'text',
    width: 300
  },
  {
    field: 'username',
    title: 'Changed by',
    filter: 'text',
    width: 150
  },
  {
    field: 'timeOfChangeShow',
    title: 'Time of change (UTC)',
    filter: 'text',
    filterable: false,
    width: 100
  },
];



// WEBPACK FOOTER //
// ./src/pages/change-history/change-history-component/change-history.config.ts